import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
} from '@mui/material';
import { Control, FieldValues } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Form } from '~/features/ScheduledEmploymentChanges/ScheduleChanges/useScheduleChanges';
import {
  EditCustomDataFields,
  EditCustomField,
} from '~/legacy-components/CustomDataFields';

export const CustomDataDialogComponent = ({
  open,
  onClose,
  control,
  customFields,
}: {
  open: boolean;
  onClose: () => void;
  customFields?: EditCustomField[];
  control: Control<Form>;
}) => {
  const { t } = useTranslation();
  return (
    <Dialog open={open} onClose={onClose} sx={{ p: 4 }}>
      <DialogTitle>{t('laCustomData')}</DialogTitle>
      <DialogContent>
        <Stack spacing={2} direction="column" sx={{ mt: 2 }}>
          {typeof customFields === 'undefined' && (
            <Alert severity={'info'}>{t('noCustomDataFieldsConfigured')}</Alert>
          )}
          {customFields?.map((customField, index) => (
            <EditCustomDataFields
              control={control as unknown as Control<FieldValues>}
              {...customField}
              key={`${index}/${customField.name}`}
            />
          ))}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('close')}</Button>
      </DialogActions>
    </Dialog>
  );
};
